import React from 'react';

import {
    AppLayout,
} from 'AWS-UI-Components-React';
import Navigation from "./navigation";
import {ReportCard} from "./cards/report_card";






const Content = (props) => (<div className='awsui-grid awsui-util-p-s'>
    <div className='custom-home__header custom-awsui-util-pt-xxxl awsui-row'>
        <div className='col-xxs-12'>
            <div className='awsui-row'>
                <div
                    className='custom-home__header-title col-xxs-10 offset-xxs-1 col-s-10 col-l-11 offset-l-1 col-xl-10'>
                    <div className='awsui-text-large'>
                        <div><strong>Search Reports</strong></div>
                    </div>

                    <div className='beersTable'>
                        {/*<Tabs tabs={tabs} activeTabId="first"></Tabs>*/}
                        <ReportCard searchId={props.searchId}/>
                    </div>


                </div>
            </div>
        </div>
    </div>
</div>);

export class ReportsDetails extends React.Component {

    constructor(props) {
        super(props);
        console.log(props);
        this.state = {
            date: {
                "end": "",
                "start": ""
            },
            searchId: this.props.match.params.id,
            taskLoadDone: false
        };
    }

    render() {
        return (
            <div className="awsui">
                <AppLayout
                    className='awsui-util-no-gutters'
                    content={<Content searchId={this.state.searchId}/>}
                    navigation={<Navigation activeHref="#/"/>}
                    navigationOpen={true}
                    toolsHide={false}
                />
            </div>

        );
    }
}


// WEBPACK FOOTER //
// ./src/components/reportsdetails.jsx